import ApiService from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        listMailVirtuali: [],
        listMail: [],
        listFolders: [],
        listUtenti: [],
        loading: false,
        globalLoading: false,
        error: {},
    },
    getters: {
        getListMailVirtuali: (state) => state.listMailVirtuali,
        getListMail: (state) => state.listMail,
        getListFolders: (state) => state.listFolders,
        getListUtentiByIDMailVirtule: (state) => state.listUtenti,
        getLoading: (state) => state.loading,
        error: (state) => state.error,
    },
    mutations: {
        SET_MAIL_VIRTUALI_LIST(state, listMailVirtuali) {
            state.listMailVirtuali = listMailVirtuali;
        },
        SET_MAILVIRTUALI_LIST(state, list) {
            state.listMail = list;
        },

        SET_FOLDERS_LIST(state, listFolders) {
            state.listFolders = listFolders;
        },
        SET_LIST_UTENTI(state, listUtenti) {
            state.listUtenti = listUtenti;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_GLOBAL_LOADING(state, val) {
            state.globalLoading = val;
        },
        SET_ERROR(state, val) {
            state.error = val;
        },
    },
    actions: {
        PAGINATED_LIST({ commit }, query) {
            commit("SET_LOADING", true);
            return new Promise((resolve) => {
                ApiService.get(`MailVirtuali/paginated?${query}`)
                    .then(({ data }) => {
                        commit("SET_MAIL_VIRTUALI_LIST", data);
                        commit("SET_LOADING", false);

                        resolve(data);
                    })
                    .catch((res) => {
                        commit("SET_ERROR", res.data.error);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_LOADING", false);
                    });
            });
        },
        FETCH_LIST_MAIL_VIRTUALI({ commit }) {
            commit("SET_LOADING", true);

            return new Promise((resolve) => {
                ApiService.get(`MailVirtuali/listDdl`)
                    .then((res) => {
                        commit("SET_MAIL_VIRTUALI_LIST", res.data);
                        commit("SET_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => {
                            commit("SET_ERROR", "");
                            commit("SET_LOADING", false);
                        }, 5000);
                    });
            });
        },
        CREATE_MAIL({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);
            return new Promise((resolve, reject) => {
                ApiService.post(`MailVirtuali`, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
        GET_MAIL({ commit }, id) {
            return new Promise((resolve) => {
                ApiService.download(`MailVirtuali`, id)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },
        GET_LIST_FOLDERS_BY_ID_MAIL_VIRTUALE({ commit }, id) {
            return new Promise((resolve) => {
                ApiService.get(
                    `MailVirtuali/listDdlFoldersByIdMailVirtuale?idMailVirtuale=${id}`
                )
                    .then((res) => {
                        commit("SET_FOLDERS_LIST", res.data);
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },

        GET_LIST_MAIL_BY_ID_MAIL_REALE({ commit }, id) {
            return new Promise((resolve) => {
                ApiService.get(
                    `MailVirtuali/listDdlByIdMailReale?idMailReale=${id}`
                )
                    .then((res) => {
                        commit("SET_MAILVIRTUALI_LIST", res.data);
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },

        GET_LIST_UTENTI_BY_ID_MAIL_VIRTUALE({ commit }, payload) {
            return new Promise((resolve) => {
                ApiService.get(
                    `Users/getUtentiForDelega?idCliente=${payload.idCliente}&idMailVirtuale=${payload.idMailVirtuale}`
                )
                    .then((res) => {
                        commit("SET_LIST_UTENTI", res.data);
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },

        // GES-1: mail virtuali collegabili (nel perimetro del cliente dell'utente)
        LIST_ORIGINI_DISPONIBILI({ commit }) {
            return new Promise((resolve, reject) => {
                ApiService.get(`MailVirtuali/originiDisponibili`)
                    .then((res) => resolve(res.data?.data || []))
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        reject(response);
                    });
            });
        },
        UPDATE_MAIL({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);
            return new Promise((resolve, reject) => {
                ApiService.update(`MailVirtuali`, params.id, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
    },
};
